"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.delete.confirm.title': 'Elimina Domanda',
    'question.delete.confirm.message': 'Sei sicuro di voler eliminare questa domanda?',
};
